module.exports = __webpack_public_path__ + "static/media/church2.de1d318b.jpg";